
import React from "react";
import "../styles/Dashboarddd.css";

const Dashboard = () => {

const branches = [
    { name: "Branch 1", collection: 10, disbursement: 10, pending: 10, npa: 0 },
    { name: "Branch 2", collection: 20, disbursement: 20, pending: 20, npa: 0 },
    { name: "Branch 3", collection: 30, disbursement: 30, pending: 30, npa: 0 },
    { name: "Branch 4", collection: 40, disbursement: 40, pending: 40, npa: 0 },
  ];

  const data={
    coll:"30000",
    disb:"20000",
    pen:"10000",
  }

  return (
    <div className="dashboards-container">
      {/* HEADER */}
      
          <div className="dashboards-filter-box">
          <h2>Techvision</h2>
        <input
          type="text"
          placeholder="Search customer,transaction..."
          // value={searchQuery}
          // onChange={(e) => setSearchQuery(e.target.value)}
        />

        {/* <select value={accountType} onChange={(e) => setAccountType(e.target.value)}> */}
        <select>
          <option value="">All Branches</option>
          <option value="dashboards-branch">Branch 1</option>
          <option value="dashboards-branch">Branch 2</option>
          <option value="dashboards-branch">Branch 3</option>
          <option value="dashboards-branch">Branch 4</option>
        </select>

        <select>
          <option value="">Branch Date</option>
          <option value="dashboards-Date">Today</option>
          <option value="dashboards-Date">This Week</option>
          <option value="dashboards-Date">Last 30 days</option>
          <option value="dashboards-Date">This Quarter</option>
          <option value="dashboards-Date">This Year</option>
        </select>
      </div>
        
      


       


      {/* OVERVIEW CARDS */}
      <div className="dashboards-overview-section">
        <div className="dashboards-overview-card">
          <div className="dashboards-overview-card-paragraph">
          <p>This Month</p>
          <h3 className="dashboards-collection-header">Collection </h3>
          <h2>23,491</h2>
        </div></div>

        <div className="dashboards-overview-card">
          <p>This Month</p>
          <h3 className="dashboards-pending-header">Pending Collection</h3>
          <h2>4,862</h2>
        </div>

        <div className="dashboards-overview-card">
          <p>This Month</p>
          <h3 className="dashboards-disbursement-header">Disbursement</h3>
          <h2>3,574</h2>
        </div>

        <div className="dashboards-overview-card">
          <p>This Month</p>
          <h3 className="dashboards-pendingdisb-header">Pending Disbursement</h3>
          <h2>3,574</h2>
        </div>
      </div>

      


     <div className="dashboards-sections">
  {/* LEFT SECTION */}
  <div className="dashboards-left-section cardBox">
    <h4>Key ledgers</h4>
    <h2>Balance Snapshot</h2>
   <div className="dashboards-balance-grid">
      <div className="dashboards-balance-item">Total Branches<br />00</div>
      <div className="dashboards-balance-item">Total<br />00</div>
      <div className="dashboards-balance-item">Cashbook<br />00</div>
      <div className="dashboards-balance-item">Bankbook<br />00</div>
      <div className="dashboards-balance-item">Charges<br />00</div>
      <div className="dashboards-balance-item">Collection<br />00</div>
      <div className="dashboards-balance-item">Disbursement<br />00</div>
      <div className="dashboards-balance-item">Outstanding<br />00</div>
    </div>

  </div>
  {/* RIGHT SECTION */}
  <div className="dashboards-right-section cardBox">
    <h4>Navigate fast</h4>
    <h2>Quick Actions</h2>
    <div className="dashboards-quick-grid">
      <button className="dashboards-action-btn">Customer</button>
      <button className="dashboards-action-btn">Employee</button>
      <button className="dashboards-action-btn">Loan</button>
      <button className="dashboards-action-btn">Collection</button>
      <button className="dashboards-action-btn">Due Report</button>
      <button className="dashboards-action-btn">Loan Scheme</button>
    </div>
    </div> 
          
          {/* Task & Alert */}

          <div className="dashboards-tasks-alerts-card">
      <p className="dashboards-top-heading">Operational</p>
      <h3 className="dashboards-main-title">Tasks & Alerts</h3>

      <div className="dashboards-task-item">
        <div>
          <p className="dashboards-task-title">pending disbursements</p>
          <p className="dashboards-task-desc">Review and approve before EOD.</p>
        </div>
        <button className="dashboards-task-btn">Review</button>
      </div>

      <hr />

      <div className="dashboards-task-item">
        <div>
          <p className="dashboards-task-title">KYC updates required</p>
          <p className="dashboards-task-desc">Customers with expired documents.</p>
        </div>
        <button className="dashboards-task-btn">Update KYC</button>
      </div>

      {/* <hr /> */}

      {/* <div className="dashboards-task-item-no-btn">
        <div>
          <p className="dashboards-task-title-blue">System health: All services operational</p>
          <p className="dashboards-task-desc">No incidents reported in the last 24h.</p>
        </div>
      </div> */}
      </div>

      
  </div>

  
{/* TRANSACTIONS */}
      <div className="dashboards-transactions-section">
        
            <div className="dashboards-transaction-header">
              <h3>Latest Transactions</h3>
              <h2 className="dashboards-trans-collection">Total Collection: {data.coll}</h2>
              <h2 className="dashboards-trans-disb">Total Disburse: {data.disb}</h2>
              <h2 className="dashboards-trans-pending">Total Pending: {data.pen}</h2>
            </div>
        <table>
          <thead>
            <tr>
              <th>Branch</th>
              <th>Collection</th>
              <th>Disbursement</th> 
              <th>Pending</th>
              <th>NPA (%)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Branch 1</td>
              <td className="dashboards-red">100</td>
              <td className="dashboards-green">100</td>
              <td className="dashboards-orange"> $90.0</td>
              <td className="dashboards-black"> 0%</td>
            </tr>
            <tr>
              <td>Branch 2</td>
              <td className="dashboards-red">100</td>
              <td className="dashboards-green">100</td>
              <td className="dashboards-orange"> $90.0</td>
              <td className="dashboards-black"> 0%</td>
            </tr>
            <tr>
              <td>Branch 2</td>
              <td className="dashboards-red">100</td>
              <td className="dashboards-green">100</td>
              <td className="dashboards-orange"> $90.0</td>
              <td className="dashboards-black"> 0%</td>
            </tr>
          </tbody>
        </table>
      </div>


          



      {/* TRANSACTIONS */}
      <div className="dashboards-transactions-section">
        <h3>Recent Transactions</h3>
        <p>Latest Activity</p>
        <table>
          <thead>
            <tr>
              <th>Txn ID</th>
              <th>Type</th>
              <th>Party</th> 
              <th>Amount</th>
              <th>Branch</th>
              <th>Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>TXN-98231</td>
              <td className="dashboards-red"><span>Collection</span></td>
              <td>Rahul Kumar</td>
              <td className="dashboards-red">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
            <tr>
              <td>TXN-98231</td>
              <td className="dashboards-green"><span>Disbursement</span></td>
              <td>Rahul Kumar</td>
              <td className="dashboards-green">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
            <tr>
              <td>TXN-98231</td>
              <td className="dashboards-orange">Charge</td>
              <td>Rahul Kumar</td>
              <td className="dashboards-orange">- $90.0</td>
              <td>Branch 1</td>
              <td>10:22 AM</td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>
  );
};

export default Dashboard;





{/* <div className="dashboards-summary-card">
      <h3 className="dashboards-summary-title">Branch Summary</h3>

      {branches.map((item, index) => (
        <div key={index} className="dashboards-branch-section">
          <div className="dashboards-row">
            <span className="dashboards-label">{item.name}</span>
            <span className="dashboards-value">Collection: {item.collection}</span>
          </div>

          <div className="dashboards-row">
            <span className="dashboards-label-header">Disbursement:</span>
            <span className="dashboards-value">{item.disbursement}</span>
          </div>

          <div className="dashboards-row">
            <span className="dashboards-label-header">Pending:</span>
            <span className="dashboards-label">{item.pending}</span>
          </div>

          <div className="dashboards-row">
            <span className="dashboards-label-header">NPA %:</span>
            <span className="dashboards-value">{item.npa}%</span>
          </div>

          {index !== branches.length - 1 && <hr />}
        </div>
      ))}
    </div>*/}


    

 

    // <div className="dashboards-pie-summary-card">
    //   <div className="dashboards-ppie-header-row">
    //     <h3>Summary</h3>
    //     <button className="dashboards-pie-view-btn">View Report</button>
    //   </div>

    //   <p className="dashboards-pie-date-text">Data from 1–12 Apr, 2024</p>

    //   <div className="dashboards-pie-content-row">
        
    //     <div className="dashboards-donut-wrap">
    //       <div className="dashboards-pie-donut">
    //         <div className="dashboards-pie-center-text">
    //           <h2>$8,295</h2>
    //           <span className="dashboards-pie-percent">↓ 2.1%</span>
    //         </div>
    //       </div>
    //     </div>

        
    //     <div className="dashboards-pie-legend">
    //       <div className="dashboards-pie-item">
    //         <span className="dashboards-pie-green"></span> Collection <span className="value">48%</span>
    //       </div>
    //       <div className="dashboards-pie-item">
    //         <span className="dashboards-pie-pink"></span> Disbursement <span className="value">13%</span>
    //       </div>
    //       <div className="dashboards-pie-item">
    //         <span className="dashboards-pie-orange"></span> Pending <span className="value">7%</span>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  